import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { useDemo } from '../demo/DemoProvider';

interface UpgradeBannerProps {
  isSidebarCollapsed: boolean;
}

export function UpgradeBanner({ isSidebarCollapsed }: UpgradeBannerProps) {
  const { isDemo, setDemo } = useDemo();
  const label = isDemo ? 'Select Subscription' : 'Upgrade to Pro';
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
    if (isDemo) {
      try {
        setDemo(false);
      } catch (error) {
        console.error(error);
      }
    }
  };
  return (
    <Link
      to="/account?tab=subscription"
      data-ph-capture-attribute="nav-premium"
      className={`
        flex items-center px-3 py-2 text-sm rounded-lg
        bg-[#E34290] hover:bg-[#E34290]/90 transition-colors shadow-sm
        ${isSidebarCollapsed ? 'justify-center px-0 mx-2' : 'mx-2'}
      `}
      title={isSidebarCollapsed ? label : undefined}
      onClick={handleClick}
    >
      <Star
        className={`${isSidebarCollapsed ? 'h-5 w-5 text-white' : 'h-4 w-4 mr-3 text-white'}`}
      />
      <span className={`${isSidebarCollapsed ? 'hidden' : ''} text-white font-medium`}>
        {label}
      </span>
    </Link>
  );
}
